/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {CatalogItemImage} from '../../../../catalogo/components/CatalogItemImage'
import catalogStyles from '../../../../catalogo/catalogo.module.css'

type Props = {
  produtos: any[]
  setMyTypeService: any
  setShowCreateAppModal: any
  setShowCreateAppModalDelete: any
  setShowCreateAppModalDetails: any
}

const getStockClass = (qtd: number) => {
  if (qtd <= 0) return catalogStyles.stockEmpty
  if (qtd <= 5) return catalogStyles.stockLow
  return catalogStyles.stockOk
}

export function TableBody({
  produtos,
  setMyTypeService,
  setShowCreateAppModal,
  setShowCreateAppModalDelete,
}: Props) {
  const handleButtonClickDelete = (event: any, product: any) => {
    event.stopPropagation()
    setMyTypeService(product)
    setShowCreateAppModalDelete(true)
  }

  const handleButtonClickUpdate = (event: any, product: any) => {
    event.stopPropagation()
    product.idsUnitBranch =
      product.unitBranchs?.length > 0
        ? product.unitBranchs.map((unitBranch: any) => unitBranch.id)
        : []
    setMyTypeService(product)
    setShowCreateAppModal(true)
  }

  return (
    <tbody>
      {produtos && produtos.length !== 0 ? (
        produtos.map((produto: any) => {
          const stock = Number(produto.qtd ?? 0)

          return (
            <tr key={produto.id}>
              <td>
                <div className='d-flex align-items-center'>
                  <div className='me-4'>
                    <CatalogItemImage
                      imageKey={produto.image}
                      fallbackIcon='/media/icons/duotune/ecommerce/ecm003.svg'
                    />
                  </div>
                  <div className='d-flex justify-content-start flex-column'>
                    <span className='text-dark fw-bold text-hover-primary fs-6'>
                      {produto.name || 'Sem nome'}
                    </span>
                    <span className='text-muted fw-semibold d-block fs-7'>
                      {produto.description || 'Sem descrição'}
                    </span>
                  </div>
                </div>
              </td>

              <td>
                <span className='text-dark fw-bold fs-6'>
                  {produto.preco != null
                    ? `R$ ${Number(produto.preco).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`
                    : '—'}
                </span>
              </td>

              <td>
                <span className={`${catalogStyles.stockBadge} ${getStockClass(stock)}`}>
                  {stock}
                </span>
              </td>

              <td>
                <div className='d-flex justify-content-end flex-shrink-0'>
                  <a
                    onClick={(event: any) => handleButtonClickUpdate(event, produto)}
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a>
                  <a
                    onClick={(event: any) => handleButtonClickDelete(event, produto)}
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  >
                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                  </a>
                </div>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={4} style={{textAlign: 'center'}}>
            <div className='d-flex justify-content-center' style={{padding: '2rem'}}>
              <span className='text-muted fw-semibold d-block fs-4'>
                Nenhum produto encontrado
              </span>
            </div>
          </td>
        </tr>
      )}
    </tbody>
  )
}
